import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import assert from 'assert';
import {typeCheck} from 'type-check';
import ApiService, { ProductDatum } from '../../services/ApiService';
import { Product, ProductDetailItem, ProductFeed } from '@server/other/classes';

export interface ProductSliceState {
  isGettingFeed: boolean,
  isGettingProduct: boolean,
  isSearching: boolean,
  feed: ProductFeed | null,
  product: ProductDatum | null,
  searchResults: {
    items: ProductDatum[];
    pagination: {
      total: number;
      limit: number;
      offset: number;
      hasMore: boolean;
    };
    searchInfo: {
      query: string;
      resultsCount: number;
      sortBy: string;
    };
  } | null,
  // products: {string?: ProductDatum},
}

const initialState: ProductSliceState = {
  isGettingFeed: false,
  isGettingProduct: false,
  isSearching: false,
  feed: null,
  product: null,
  searchResults: null,
  // products: {},
};

export const getProductFeed = createAsyncThunk(
  'products/getProductFeed', async (idToken: string) => {
    const result = await ApiService.getInstance()
      .getProductFeed();
    return result;
});

export const searchProducts = createAsyncThunk(
  'products/searchProducts', async (params: {
    query: string;
    limit?: number;
    offset?: number;
    sortBy?: 'relevance' | 'newest' | 'popular';
  }) => {
    const result = await ApiService.getInstance()
      .searchProducts(params.query, {
        limit: params.limit,
        offset: params.offset,
        sortBy: params.sortBy,
      });
    return result;
});

export const getProductbyId = createAsyncThunk(
  'products/getProductById', async (
    params: {
      productId: string,
    }
  ) => {
    const { productId } = params;
    assert(typeCheck('String', productId), 'productId must be string');
    const result = await ApiService.getInstance()
      .getProductById(productId);
    return result;
});

export const productsSlice = createSlice({
  name: 'products',
  initialState,
  reducers: (create) => ({
    clearEditing: create.reducer((state) => {
      state.isGettingFeed = false;
    }),
  }),
  extraReducers: (builder) => {
    // ------------ Get Feed ---------------
    builder.addCase(getProductFeed.pending, (state, action) => {
      state.isGettingFeed = true;
    }).addCase(getProductFeed.fulfilled, (state, action) => {
      state.isGettingFeed = false;
      state.feed = action.payload;
      // const newProducts = {...state.products};
      // Object.values(action.payload).forEach((product) => {
      //   if (product.id) {
      //     newProducts[product.id] = product;
      //   }
      // });
      // state.products = newProducts;
    }).addCase(getProductFeed.rejected, (state, action) => {
      state.isGettingFeed = false;
    });

    // ------------ Get Product By ID ---------------
    builder.addCase(getProductbyId.pending, (state, action) => {
      state.isGettingProduct = true;
    }).addCase(getProductbyId.fulfilled, (state, action) => {
      state.isGettingProduct = false;
      state.product = action.payload;
    }).addCase(getProductbyId.rejected, (state, action) => {
      state.isGettingProduct = false;
    });

    // ------------ Search Products ---------------
    builder.addCase(searchProducts.pending, (state, action) => {
      state.isSearching = true;
    }).addCase(searchProducts.fulfilled, (state, action) => {
      state.isSearching = false;
      state.searchResults = action.payload;
    }).addCase(searchProducts.rejected, (state, action) => {
      state.isSearching = false;
    });

  },
  selectors: {
    selectFeed: (state) => state.feed,
    selectProduct: (state) => state.product,
    selectSearchResults: (state) => state.searchResults,
    selectIsSearching: (state) => state.isSearching,
  },
});

export const {
  selectFeed,
  selectProduct,
  selectSearchResults,
  selectIsSearching,
} = productsSlice.selectors;

export const {
} = productsSlice.actions;

export default productsSlice.reducer;